import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmailProviderService {
  private url = "";
  private readonly api_key = '9C7B824B5E6BCB39FEACCDE24AEBBA0D8A99C2705A8E24F578CD45453F22348DB45DA2D81F4D20AC8C5D8AC8A7626DF5';

  constructor(
    private http: HttpClient
  ) { }

  

  // SendEmail(input: any) {
	//   return this.http.post(this.url, input, response).pipe(
	// 	map((response) => {
  //     if (response) {
	// 		  return response
	// 	  }
	// 	},
	// 	(error) => {
  //     if (error) {
	// 		  return error
	// 	  }
	// 	}))}
}
